module.exports = __webpack_public_path__ + "9e4411983b546767f9b9b2f572b07b78.svg";